import { render, staticRenderFns } from "./Brackets.vue?vue&type=template&id=56e6333d&scoped=true"
import script from "./Brackets.vue?vue&type=script&lang=js"
export * from "./Brackets.vue?vue&type=script&lang=js"
import style0 from "./Brackets.vue?vue&type=style&index=0&id=56e6333d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e6333d",
  null
  
)

export default component.exports